export interface ZwinkerExtendedData {
	profile?: number;
	lp?: string;
	subsource?: string;
}
export async function Signup(targetUrl: string, email: string, failUrl: string, extendedData: ZwinkerExtendedData = {}) {
	const response = await fetch(targetUrl, {
		method: 'POST',
		cache: 'no-cache',
		mode: 'cors',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			email: email,
			...extendedData
		})
	})

	const data = await response.json();

	if (data.success === true && typeof data.data !== null) {
		window.location.href = data.data;
	} else {
		window.location.href = failUrl;
	}
}

export async function ExtendedSignup(targetUrl: string, failUrl: string, email: string, zip: string, hostId: number, age: number, extendedData: ZwinkerExtendedData = {}) {
	const response = await fetch(targetUrl, {
		method: 'POST',
		cache: 'no-cache',
		mode: 'cors',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			email: email,
			zip: zip,
			age: age,
			hostId: hostId,
			...extendedData
		})
	})

	const data = await response.json();

	if (data.success === true && typeof data.data !== null) {
		window.location.href = data.data;
	} else {
		window.location.href = failUrl;
	}
}

export function checkEmail(email:string): boolean {
	return email.match(/^.+@.+\..+$/) !== null;
}

export function isFilled(content: string): boolean {
	return content.trim().length !== 0;
}
